import React, { useEffect, useState } from 'react';
import { host_url } from '../../App';
import './JobsVerwaltung.css';
import '../../styles/CiTable.css';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import SuccessModal from '../../SuccessModal';

function JobsVerwaltung() {
  const [jobs, setJobs] = useState([]);
  const [slots, setSlots] = useState({});
  const [units, setUnits] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [totalChildrenPerUnit, setTotalChildrenPerUnit] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    fetch(`${host_url}/jobs`)
      .then(res => res.json())
      .then(data => setJobs(Array.isArray(data) ? data : []))
      .catch(err => console.error('Fehler beim Laden der Jobs:', err));
  }, []);

  useEffect(() => {
    fetch(`${host_url}/jobs_verfuegbarkeiten`)
      .then(res => res.json())
      .then(data => {
        // Backend liefert bei DB-Fehlern ein Fehler-Objekt statt Array — nicht crashen
        if (!Array.isArray(data)) {
          console.error('Unerwartete Antwort von /jobs_verfuegbarkeiten:', data);
          return;
        }
        const s = {}, u = {};
        data.forEach(({ JobID, EinheitID, Slots, EinheitName }) => {
          if (!s[JobID]) s[JobID] = {};
          s[JobID][EinheitID] = Number(Slots);
          u[EinheitID] = EinheitName;
        });
        setSlots(s);
        setUnits(u);
      })
      .catch(err => console.error('Fehler beim Laden der Verfügbarkeiten:', err));

    fetch(`${host_url}/einheit_details_with_jobs`)
      .then(res => res.json())
      .then(data => {
        if (!Array.isArray(data)) {
          console.error('Unerwartete Antwort von /einheit_details_with_jobs:', data);
          return;
        }
        const map = {};
        data.forEach(({ EinheitID, KinderInEinheit }) => {
          map[EinheitID] = KinderInEinheit;
        });
        setTotalChildrenPerUnit(map);
      })
      .catch(err => console.error('Fehler beim Laden der Einheiten-Details:', err));
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasChanges]);

  const handleSlotsChange = (jobId, einheitId, value) => {
    setSlots(prev => ({
      ...prev,
      [jobId]: {
        ...prev[jobId],
        [einheitId]: Number(value)
      }
    }));
    setHasChanges(true);
  };

  const handleSubmit = () => {
    const body = Object.entries(slots).flatMap(([jobId, units]) =>
      Object.entries(units).map(([einheitId, Slots]) => ({
        JobID: jobId,
        EinheitID: einheitId,
        Slots
      }))
    );

    fetch(`${host_url}/jobs_verfuegbarkeiten`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setSuccessMsg('Slots erfolgreich aktualisiert');
          setHasChanges(false);
        } else {
          alert('Fehler beim Aktualisieren der Slots');
        }
      });
  };

  const filteredJobs = jobs
    .filter(j => j.Name.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => a.Name.localeCompare(b.Name));

  const totalSlotsPerUnit = Object.keys(units).reduce((acc, eid) => {
    acc[eid] = Object.values(slots).reduce((sum, job) => sum + (job[eid] || 0), 0);
    return acc;
  }, {});

  return (
    <KernteamLayout>
      <div className="full-width-container">
      <BackArrow to="/arbeit" onBeforeNavigate={() => !hasChanges || window.confirm('Nicht gespeicherte Änderungen verwerfen?')} />
      <div className="jobsverwaltung-wrapper">
        <h1 className="section-title orange">Jobverfügbarkeiten verwalten</h1>

        <div className="jobs-suche-wrapper">
          <span className="material-symbols-outlined search-icon">search</span>
          <input
            type="text"
            placeholder="DURCHSUCHEN..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>

        <button className="jobbutton" onClick={handleSubmit}>
          Änderungen speichern
        </button>

        <div className="ci-table-wrapper">
          <table className="ci-table">
            <thead>
              <tr>
                <th>JOB</th>
                {Object.keys(units).map(id => (
                  <th key={id}>{units[id]}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredJobs.map(job => (
                <tr key={job.JobID}>
                  <td className="job-name">{job.Name}</td>
                  {Object.keys(units).map(eid => (
                    <td key={eid} className="slot-cell">
                      <div className="slot-input-wrapper">
                        <input
                          className="slot-input"
                          type="number"
                          min="0"
                          value={slots[job.JobID]?.[eid] || 0}
                          onChange={e =>
                            handleSlotsChange(job.JobID, eid, e.target.value)
                          }
                        />
                        {((slots[job.JobID]?.[eid] || 0) > 0) && ((slots[job.JobID]?.[eid] || 0) < (job.Mindestanzahl !== undefined ? job.Mindestanzahl : 2)) && (
                          <span className="material-symbols-outlined warning-icon" title={`Mindestanzahl: ${job.Mindestanzahl !== undefined ? job.Mindestanzahl : 2}`}>warning</span>
                        )}
                      </div>
                    </td>
                  ))}
                </tr>
              ))}
              <tr className="summary-row">
                <td><strong>Summe / Kinder</strong></td>
                {Object.keys(units).map(id => (
                  <td key={id}>
                    <strong>{totalSlotsPerUnit[id] || 0}</strong> /{' '}
                    <span>{totalChildrenPerUnit[id]}</span>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      </div>
      <SuccessModal message={successMsg} onClose={() => setSuccessMsg('')} />
    </KernteamLayout>
  );
}

export default JobsVerwaltung;
